import "./ReikiTherapy.module.css";
import Header from "@/reusable_sections/Header";
import Reiki from "./sections/Reiki";
import ReikiProcess from "./sections/ReikiProcess";
import Hero from "./sections/Hero";
import Pricing from "./sections/Pricing";
import Footer from "@/reusable_sections/Footer";
import Symptoms from "./sections/Symptoms";
import TargetAudience from "./sections/TargetAudience";
import SessionCta from "./sections/SessionCta";
import ReikiGalerie from "./sections/ReikiGalerie";
import ReikiFaq from "./sections/ReikiFaq";
export default function ReikiTherapyPage() {
  return <div>
      <Header />
      <Reiki />
      <Symptoms />
      <ReikiProcess />
      <TargetAudience />
      <SessionCta />
      <ReikiGalerie />
      <Hero />
      <Pricing />
      <ReikiFaq />
      <Footer />
    </div>;
}